import { render, staticRenderFns } from "./ElementsList.vue?vue&type=template&id=cde4701a&"
import script from "./ElementsList.vue?vue&type=script&lang=ts&"
export * from "./ElementsList.vue?vue&type=script&lang=ts&"
import style0 from "./ElementsList.vue?vue&type=style&index=0&id=cde4701a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports